<template>
  <div :class="isRTLPage ? 'right-align' : 'left-align'">
    <BreadCrumb type="area" :data="linkData" v-if="linkData" />
    <Banner :banner="bannerImages"/>
    <div class="my-5 hotelplusflight">
      <div class="container" style="direction: rtl;">
        <div class="row">
          <Sidebar :remarks="remarks" :hotelName="hotelName" :destination="destinationName" v-if="hotel" />
          <div :class="['filter-cont', 'dVacation-pack', hotel ? 'col-md-9' : 'col-md-12']">
            <router-view @setBookingStage="setBookingStage" />
          </div>
        </div>
      </div>
    </div>
    <Footer page="booking" v-if="!hideFooter"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { fromBase64 } from '@/utils/base64Util';
import getProductBanner from '@/mixins/getProductBanner';

export default {
  mixins: [getProductBanner],
  components: {
    Banner: () => import('@/components/productPage/productBanner/ProductBannerTheme0'),
    BreadCrumb: () => import('@/components/productPage/Breadcrumb'),
    Sidebar: () => import('@/components/productPage/ProductSidebar'),
    Footer: () => import('@/components/content/footer/FooterTheme0'),
  },
  data() {
    return {
      product: null,

      hotel: [],

      bookingStage: 2,
      stageLabel: ['', 'product-page.package-details', 'product-page.payment-details', 'product-page.Order-Completion'],

      remarks: '',
      hotelName: '',
      destinationName: '',
    };
  },
  computed: {
    ...mapGetters({
      device: 'GET_DEVICE',
      isLoading: 'GET_LOADING_STATE',
      lang: 'GET_LANGUAGE',
      isRTLPage: 'GET_IS_RLT_PAGE',
      hideCondition: 'GET_HIDE_CONDITION',
      marketerId: 'GET_MARKETER_ID',
      agencyMarketerContent: 'GET_MARKETER_AGENCY_CONTENT',
    }),
    linkData() {
      return {
        text: this.hotelName,
        dest: this.destinationName,
        stage: this.$t(this.stageLabel[this.bookingStage]),
      };
    },
    hideFooter() {
      const hide = this.device === 'desktop' && (this.hideCondition || (this.marketerId !== '' && this.agencyMarketerContent?.marketerSpecificContents?.hideFooter));
      return hide;
    },
  },
  watch: {
    lang: 'updateLabelWithLang',
  },
  methods: {
    fetchData() {
      this.product = JSON.parse(fromBase64(window.localStorage.getItem('production')));

      this.hotel = this.product.hotel;
      this.updateLabelWithLang();
      this.hotelName = this.hotel.hotelName;
      this.destinationName = this.hotel.cityName;
    },
    setBookingStage(pStage) {
      this.bookingStage = pStage;
    },
    updateLabelWithLang() {
      this.remarks = '';
    },
  },
  created() {
    this.$store.commit('SET_CURRENT_PAGE', 'booking');
    this.fetchData();
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.left-align .row {
  text-align: left;
}
.left-align .dVacation-pack {
  direction: ltr;
}
.retingbox .rating {
  height: auto;
  color: black;
  background: transparent;
  border: none;
  padding: 0;
  width: auto;
}
.clearfix {
  clear: both;
}
.hotelplusflight_body,
.mobail_part {
  display: none;
}

@media (max-width: 479px) {
  .holiday-hotel-details,
  .facilitie-list,
  .price-composition-desktop {
    display: none;
  }
  .hotelplusflight_body,
  .mobail_part {
    display: block;
  }
  .product-page-flight .filterItem {
    margin: 0;
  }
  .dVacation-pack {
    padding: 10px;
  }
  .my-5.hotelplusflight {
    margin-bottom: 5rem !important;
  }

}

@media ( max-width:767.98px){
  .hotelplusflight > .container{
    max-width : 100%;
  }
}

@media ( max-width : 991.98px){
  .sideBar{
    display: none;
  }

  .dVacation-pack{
    max-width: 100%;
  }

}

@media (min-width: 768px) and (max-width:991.98px) {
  .filter-cont.dVacation-pack{
      flex : none !important;
  }
}
</style>
